class MessagesUtil {
  constructor() {
    this.initUtil = true;
  }

  static showToast(
    toast,
    severityValue,
    summaryValue,
    detailValue,
    sticky = false,
    life = 6000,
    icon,
    style
  ) {
    try {
      toast.current.show({
        severity: severityValue,
        summary: summaryValue,
        detail: detailValue,
        sticky: sticky,
        life: life,
        icon: icon,
        style: style,
      });
    } catch (e) { }
  }
}

export default MessagesUtil;
